import React from 'react'
import PropTypes from 'prop-types'
import { Label, Table, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'

const ContratoEnergiaInstalacao = (props) => (
  <CRUDIndex noTitle padded={false}
    onRedirectToNew={props.onRedirectToNew}
    onExportToCSV={props.onExportToCSV}
    filterText={props.filterText}
    handleFilter={props.handleFilter}
  >
    <Table sortable celled striped selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} textAlign='center'
            onClick={props.handleSort('id')}
            sorted={props.handleSorted('id')}>#</Table.HeaderCell>
          <Table.HeaderCell width={3}
            onClick={props.handleSort('ano_inicial')}
            sorted={props.handleSorted('ano_inicial')}>Ano Início</Table.HeaderCell>
          <Table.HeaderCell>Subgrupos</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.isLoading && (
          <Table.Row>
            <Table.Cell colSpan={4}>
              <Loader active={props.isLoading} inline='centered' />
            </Table.Cell>
          </Table.Row>
        )}

        {props.multipleContratoEnergiaInstalacao.valueSeq().map((contratoEnergiaInstalacao, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/instalacoes/${contratoEnergiaInstalacao.getIn(['instalacao', 'id'])}/contratos_energia/${contratoEnergiaInstalacao.get('id')}`}>{contratoEnergiaInstalacao.get('id')}</Label>
            </Table.Cell>
            <Table.Cell>{contratoEnergiaInstalacao.get('ano_inicial')}</Table.Cell>
            <Table.Cell>
              <EditDeleteButtonContainer
                onEditResource={() => props.onEditResource(contratoEnergiaInstalacao.getIn(['instalacao', 'id']), contratoEnergiaInstalacao.get('id'))}
                onDeleteResource={() => props.onDeleteResource(contratoEnergiaInstalacao.get('id'))} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </CRUDIndex>
)

ContratoEnergiaInstalacao.propTypes = {
  isLoading: PropTypes.bool,
  multipleContratoEnergiaInstalacao: PropTypes.object,

  onRedirectToNew: PropTypes.func,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,

  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
}

export default ContratoEnergiaInstalacao
